import { MenuItemCategory, MenuItemType, NavObjectType, jsxParams } from "../Components/navigationTypes";
import { AddMenu } from './addMenu';
import { MenuItem } from "./menuItem";
import { Alert, ListGroup, Button } from 'react-bootstrap';
import { IndicatorBadgeType } from "./sideTypes";
import { runInnerFunction } from "../compatManager";
import { useContext } from "react";
import { NavigationContext } from "../Context/NavigationContext";
import React from "react";
import { useAppSelector } from "../redux/hooks";
import { lddStateObject } from "../redux/reducer";
import { displayToastMsg } from "../Components/toastMessages/toastmessages";

export function navItem(menuState: Record<string, boolean>, toggleMenuState: (element: string) => () => void, numOfTabs: number, page?: NavObjectType) {
    return (item: MenuItemType, navItemIndex: number) =>
        <NavigationElement
            key={item.label + item.type + navItemIndex}
            item={item}
            menuState={menuState}
            toggleMenuState={toggleMenuState}
            numOfTabs={numOfTabs}
            navItemIndex={navItemIndex}
            page={page}
        />
}

const TOGGLE_THRESHOLD = 0;

const MoreLessToggle = (props: {
    size: number,
    less: boolean,
    toggleMenuState: ((menuState:string) =>React.MouseEventHandler<HTMLElement>),
    label: string,
    expandable: boolean,
    maxSize: number,
}) => {
    props.toggleMenuState(props.label)
    return (
        <i onClick={props.toggleMenuState(props.label)} className={props.less ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'}></i>
    )
}

const renderConfiguredElement = (
    item: jsxParams["jsx"][number],
    key: string,
) => {
    const { tag, text, className, props: itemProps } = item;
    const propClassName = typeof itemProps?.className === "string" ? itemProps.className : undefined;
    const mergedClassName = [propClassName, className].filter(Boolean).join(" ") || undefined;
    const mergedProps = {
        key,
        ...(itemProps || {}),
        className: mergedClassName,
    };
    return text !== undefined ? React.createElement(tag, mergedProps, text) : React.createElement(tag, mergedProps);
};

const NavAlert = (props: {
    variant: string,
    text?: string,
    jsx?: jsxParams["jsx"]
}) => {
    return (
        <>
            {props.text &&
                <Alert variant={props.variant}>
                    {props.text}
                </Alert>
            }
            {props.jsx &&
                <Alert variant={props.variant} className="alert-text" style={{ fontSize: '12px'}}>
                    {props.jsx.map((item, index) => renderConfiguredElement(item, `alert-${index}`))}
                </Alert>
            }
        </>
    )
}

const DocumentSignPanel = (props: {
    variant: string,
    text?: string,
    jsx?: jsxParams["jsx"],
    textClassName?: string,
    buttonText?: string,
    onButtonClick?: () => void,
}) => {
    if (!props.text && !props.jsx) return null;
    return (
        <div className="subMenu docControlCard">
          {props.text && <div className={`doc-control-text ${props.textClassName || ""}`.trim()}>{props.text}</div>}
          {props.jsx && (
                props.jsx.map((item, index) => renderConfiguredElement(item, `line-${index}`))
          )}
          {props.buttonText && props.onButtonClick && (
            <Button
              type="button"
              variant="link-text"
              onClick={props.onButtonClick}
            >
              {props.buttonText}
            </Button>
          )}
        </div>
    );
}

const HeaderAdd = (props: {
    menu: Array<MenuItemType>,
    link: NavObjectType,
    newIndex: string,
    iconType?: "ellipsis" | "default",
}) => {
    const nav = useContext(NavigationContext);
    const sessionInfo = useAppSelector((state: lddStateObject) => state.SessionInfo);
    if (props.menu.length > 0) {
        return (<AddMenu menuOptions={props.menu} nav={nav} SessionInfo={sessionInfo} iconType={props.iconType} />)
    }
    if (props.link.component === "main" && props.link.url && props.link.params) {
        props.link.params.tabNum = String(props.newIndex);
        return (
            <i className="fa-solid fa-circle-plus" onClick={() => {
                if (props.link.action > "") {
                    window.setTimeout(function () {
                        runInnerFunction(props.link.action, null);
                    }, 100)
                }
                nav(props.link)
            }} />
        )
    }
    return <></>
}
// Build Side bar out of json prop
const NavigationElement = (props: {
    item: MenuItemType,
    menuState: Record<string, boolean>
    numOfTabs: number,
    toggleMenuState: (element: string) => () => void,
    navItemIndex: number,
    page?: NavObjectType
}) => {
    const nav = useContext(NavigationContext)
    const threshold = props.item.maxSize ? props.item.maxSize : TOGGLE_THRESHOLD;
    const indicatorBadges: Array<IndicatorBadgeType> = [];
    switch (props.item.type) {
        case MenuItemCategory.Heading:
            let subItemList = props.item.subItems ? props.item.subItems : [];
            const size = subItemList.length;
            if (!props.menuState[props.item.label] && props.item.expandable) {
                subItemList = subItemList.slice(0, threshold);
            }
            const subItemElementList = subItemList.map(navItem(props.menuState, props.toggleMenuState, subItemList.length, props.page));
            const showHeadingCount = props.item.expandable && size > threshold && !(props.item.label === "Property" && props.item.appCode?.includes("RPWBC"));
            return (
                <>
                    <ListGroup.Item
                        className="optionsHover expandable-item"
                        onClick={props.item.expandable ? props.toggleMenuState(props.item.label) : undefined}
                    >
                        <i className={`fal ${props.item.icon} item-icon status-secondary`}/>
                        
                        <h4>
                            {props.item.label} 
                        </h4>

                        {(showHeadingCount && <span className="item-counter">({size})</span>)}

                        <span className="optionsContainer" onClick={(e) => e.stopPropagation()}>
                            <HeaderAdd 
                                newIndex={String(size + 1)} 
                                menu={props.item.addOptions} 
                                link={props.item.navigate}  
                                iconType={props.item.addOptionsType} 
                            />

                            <span style={{ width: '20px'}}>
                            {(!(size <= threshold || !props.item.expandable)) &&
                                <MoreLessToggle
                                    maxSize={threshold}
                                    expandable={props.item.expandable}
                                    size={size}
                                    label={props.item.label}
                                    less={props.menuState[props.item.label]}
                                    toggleMenuState={props.toggleMenuState} 
                                />
                            }
                            </span>
                        </span>
                    </ListGroup.Item>

                    <div className="subMenu">{subItemElementList}</div>
                </>
            )
        case MenuItemCategory.Blank:
            let elmts = props.item.subItems ? props.item.subItems : [];
            let elmtList = elmts.map(navItem(props.menuState, props.toggleMenuState, elmts.length));
            return (
                <>
                    {elmtList}
                </>
            )
        case MenuItemCategory.Alert:
            return (
                <>
                    <h4>{props.item.label}</h4>

                    <NavAlert
                        variant={props.item.params?.variant}
                        text={props.item.params?.text ?? null}
                        jsx={props.item.jsxParams?.jsx ?? null}
                    />

                </>
            )
        case MenuItemCategory.DocumentSign:
            return (
                <>
                    <ListGroup.Item className="noAction">
                        <i className="fal fa-signature item-icon status-secondary"></i>
                        <h4>{props.item.label}</h4>
                        {props.item.icon && (
                            <i
                                className="fa-solid fa-pencil me-auto status-action"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (props.item.navigate) nav({ label: props.item.label, ...props.item.navigate });
                                }}
                            />
                        )}
                    </ListGroup.Item>

                    <DocumentSignPanel
                        variant={props.item.params?.variant}
                        text={props.item.params?.text ?? null}
                        jsx={props.item.jsxParams?.jsx ?? null}
                    />
                </>
            )
        case MenuItemCategory.Person:
            return (
                <MenuItem
                    nav={nav}
                    menuType={props.item.type}
                    numOfTabs={props.numOfTabs}
                    agreement={props.item.params?.agreement === "1"}
                    title={props.item.params?.title === "1"}
                    label={props.item.label}
                    final={props.item.params?.final && props.item.params.final === "true"}
                    link={props.item.navigate}
                    buyer={props.item.params}
                    subIndex={props.item.type + props.navItemIndex}
                    customLabel={props.item.customLabel}
                />
            )
        case MenuItemCategory.Matter:
            let type;
            switch (props.item.params.matterType) {
                case 'All':
                    type = 'info';
                    break;
                case 'Resolved':
                    type = 'success';
                    break;
                case 'Outstanding':
                    type = 'warning';
                    break;
                default:
                    type = 'inactive'
                    break;
            }
            indicatorBadges.push({
                type: type,
                label: props.item.params['counter'],
                category: props.item.params?.badgeCategory
            })
            break;
        default:
            if (props.item.params?.badgetext !== undefined) {
                indicatorBadges.push({
                    type: props.item.params?.badgetype ? props.item.params?.badgetype : 'inactive',
                    label: props.item.params?.badgetext,
                    category: props.item.params?.badgeCategory
                })
            }
            break;
    }
    return (
        <MenuItem
            nav={nav}
            menuType={props.item.type}
            key={props.item.label + props.navItemIndex}
            link={props.item.navigate}
            label={props.item.label}
            customLabel={props.item.customLabel}
            final={props.item.params?.final && props.item.params.final === "true"}
            indicatorList={indicatorBadges}
            numOfTabs={props.numOfTabs}
            subIndex={props.item.type + props.navItemIndex}
            dropdownOptions={props.item.dropdownOptions || []}
            requiredFields={props.item.requiredFields || []}
            symbol={props.item.symbol || null}
            page={props.page}
            icon={props.item.icon}
            badge={props.item.params?.badgetext > ""}
        />)
}